import * as React from 'react';

export type DialogOptions = { isParent?: boolean };
export const DialogOptionsContext = React.createContext<DialogOptions>({});
export const useDialogOptions = () => React.useContext(DialogOptionsContext);

